import { createContext } from "react";
import CategoriesStore from "./category/CategoriesStore";
import DocumentsStore from "./document/DocumentsStore";
import JobsStore from "./jobs/JobsStore";
import ManufacturerStore from "./manufacturer/ManufacturerStore";
import MediaStore from "./media/MediaStore";
import OpportunityStore from "./opportunities/OpportunityStore";
import ProductStore from "./product/ProductStore";
import ResellerStore from "./reseller/ResellerStore";
import ReturnsStore from "./return/ReturnsStore";
import SearchStore from "./search/SearchStore";
import SnackStore from "./snacks/SnackStore";
import UiStore from "./ui/UiStore";
import UserStore from "./user/UserStore";
import WarehousesStore from "./warehouses/WarehousesStore";

class RootStore {
  readonly categoriesStore = new CategoriesStore();
  readonly documentsStore = new DocumentsStore();
  readonly jobsStore = new JobsStore();
  readonly manufacturerStore = new ManufacturerStore();
  readonly mediaStore = new MediaStore();
  readonly opportunityStore = new OpportunityStore();
  readonly productStore = new ProductStore();
  readonly resellerStore = new ResellerStore();
  readonly returnsStore = new ReturnsStore();
  readonly searchStore = new SearchStore();
  readonly snackStore = new SnackStore();
  readonly uiStore = new UiStore();
  readonly userStore = new UserStore();
  readonly warehousesStore = new WarehousesStore();
}

const rootStore = new RootStore();

export { RootStore };
export default rootStore;

// React context so components can use useContext(RootStoreContext)
export const RootStoreContext = createContext<RootStore>(rootStore);
